import { Condition, Query, QueryGroup } from '@deckplan.io/common/filters';

export class FilterUtils {

    public static translateOperation(query: Query, conditionToFind: Condition, destinationCondition: Condition) {
        if (query === null || query === undefined) {
            return;
        }
        // Run through the Query; note that this is very similar to the Backend's common/filter/Utils.VisitQueryItems() method;
        // may make sense to factor it out into the common repo as a generic visitor.
        if ((query as Condition).operation) {
            // Since we've identified a Condition object, we want to apply our hints now
            // If the current Condition is the conditionToFind, replace it with the destinationCondition
            const conditionObject = query as Condition;
            if (conditionObject.operation === conditionToFind.operation && conditionObject.value === conditionToFind.value &&
                conditionObject.dataField === conditionToFind.dataField) {

                // Need to set each of these fields individually
                conditionObject.operation = destinationCondition.operation;
                conditionObject.dataField = destinationCondition.dataField;
                conditionObject.value = destinationCondition.value;
            }
        } else if ((query as QueryGroup).operator) {
            // Since we've identified a QueryGroup, we want to apply this method to each of its operands, in case any of them
            // are Conditions (or QueryGroups containing Conditions)
            const queryGroupObject = query as QueryGroup;
            for (const operand of queryGroupObject.operands) {
                FilterUtils.translateOperation(operand, conditionToFind, destinationCondition);
            }
        }
    }
}
